import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { useChatbotContext } from 'pages/chatbot/context'
import { AgentSwitchField } from 'pages/chatbot/ui/AgentSwitchField/AgentSwitchField.tsx'
import { AgentCard } from 'pages/chatbot/ui/AgentCard/AgentCard.tsx'
import { ChatbotActions } from 'pages/chatbot/ui/ChatbotEdit/ChatbotActions'
import { HandoffNotifySettings } from 'pages/chatbot/ui/ChatbotEdit/StepHandoff/ui/HandoffNotifySettings/HandoffNotifySettings.tsx'
import styles from './styles.module.scss'

type IStepQualifyContentProps = {
  type: 'default' | 'booking'
  error?: string
}

export const StepHandoffContent = observer(({ type }: IStepQualifyContentProps) => {
  const { stepHandoffStore } = useChatbotContext()

  const { actions, enabled, setEnabled, handoffNotifySettingsStore } = stepHandoffStore

  return (
    <div
      className={classNames(styles.content, {
        [styles.booking]: type === 'booking',
      })}
    >
      <AgentSwitchField active={enabled} onChange={setEnabled} title={'Handoff to human'} isBeta />
      {enabled && (
        <>
          <HandoffNotifySettings store={handoffNotifySettingsStore} />
          <AgentCard
            title={'Actions'}
            description={'Optionally add actions when the conversation is handed off'}
            content={<ChatbotActions actions={actions} />}
          />
        </>
      )}
    </div>
  )
})
